import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { fetchCirriculum, fetchDisciplines } from '../../actions/umk';
import styles from './styles.module.css';

const selectStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    minHeight: 44,
    backgroundColor: '#fff',
    borderRadius: 10,
    borderWidth: 1.5,
    borderColor: state.isFocused ? '#7a2e33' : '#d8dbe0',
    boxShadow: state.isFocused ? '0 0 0 3px rgba(122, 46, 51, 0.12)' : 'none',
    fontSize: 15,
    '&:hover': { borderColor: state.isFocused ? '#7a2e33' : '#d8dbe0' },
  }),
  valueContainer: (baseStyles) => ({
    ...baseStyles,
    padding: '2px 13px',
  }),
  singleValue: (baseStyles) => ({
    ...baseStyles,
    color: '#2b2b2b',
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  menu: (baseStyles) => ({
    ...baseStyles,
    zIndex: 100,
  }),
};

const Filters = ({ curriculumId, disciplineId, onCurriculumChange, onDisciplineChange }) => {
  const dispatch = useDispatch();

  const curriculum = useSelector((state) => state.umk.curriculum) || [];
  const disciplines = useSelector((state) => state.umk.disciplines) || [];

  useEffect(() => {
    dispatch(fetchCirriculum(0));
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchDisciplines({ idcurriculum: curriculumId || 0, syid: 0 }));
  }, [dispatch, curriculumId]);

  const curriculumOptions = useMemo(() => [
    { value: 0, label: 'Все' },
    ...curriculum.map((item) => ({
      value: item.value || item.idcurriculum,
      label: item.label || item['Название'],
    })),
  ], [curriculum]);

  const disciplineOptions = useMemo(() => [
    { value: null, label: 'Не выбрано' },
    ...disciplines.map((item) => ({
      value: item.value || item.cid,
      label: item.name || item.label,
    })),
  ], [disciplines]);

  return (
    <div className={styles.filters}>
      <div className={`${styles.field} ${styles.fieldPlan}`}>
        <label className={styles.fieldLabel} htmlFor="pmCurriculum">Учебный план</label>
        <Select
          inputId="pmCurriculum"
          placeholder="Все"
          noOptionsMessage={() => 'Ничего не найдено'}
          styles={selectStyles}
          onChange={(option) => onCurriculumChange(option?.value || 0)}
          value={curriculumOptions.find((opt) => opt.value === curriculumId)}
          options={curriculumOptions}
        />
      </div>

      <div className={`${styles.field} ${styles.fieldDiscipline}`}>
        <label className={styles.fieldLabel} htmlFor="pmDiscipline">Дисциплина</label>
        <Select
          inputId="pmDiscipline"
          placeholder="Не выбрано"
          noOptionsMessage={() => 'Ничего не найдено'}
          styles={selectStyles}
          onChange={(option) => onDisciplineChange(option?.value ?? null)}
          value={disciplineOptions.find((opt) => opt.value === disciplineId)}
          options={disciplineOptions}
        />
      </div>
    </div>
  );
};

export default Filters;
